<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 45rem;">
          <template v-slot:header>
            <h6 class="mb-0">Historic Predictive Risk Indicators</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="warning">=</b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>An online search of both initial and drill down results for XX key terms most often associated with Human Rights violations has resulted in:</p>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-center text-primary">
            <b-col cols="12">
              <h1>XX</h1>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>Results in conjunction with [Third Party Name]. This is predicative of a [] risk indicator for Human Rights.</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p
                class="text-danger"
              >Please note that the Human Rights Historic Predictive Risk Indicator indicates only the potential for risk. It should not be used in isolation and should be used in combination with your organisation's own risk assessment, procedures and policies.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header-tag="header" style="height: 45rem;">
          <template v-slot:header>
            <h6 class="mb-0">Future Predictive Risk Benchmarks</h6>
          </template>
          <b-row class="text-center">
            <b-col cols="12">
              <b-avatar variant="danger">=</b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p>A search of [Third Party Name]’s domain has revealed the bellow results in conjunction with visibility of and preparedness for Human Rights Compliance.</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Human Rights</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <h6>Modern Slavery</h6>
              <p>Chart</p>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="12">
              <p
                class="text-danger"
              >Please note that the Human Rights Future Predicative Risk Benchmarks indicate only the prevalence of material related to ta risk area. This is not a comprehensive policy review. Should you wish for such a service please contact us to discuss.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "HumanRightsPredictiveRisk",
  data() {
    return {};
  }
};
</script>